import type {
    NCoreUIKitIcon
} from "../../../../types";
import {
    useMessageScrollerRootContext
} from "../../context";
import type {
    MessageScrollerButtonDirection
} from "../../type";
import {
    ArrowDown as ArrowDownIcon,
    ArrowUp as ArrowUpIcon,
    type LucideIcon
} from "lucide-react-native";
import AnimatedIcon from "../../../animatedIcon";

const getMessageScrollerButtonIcon = (icon: LucideIcon): NCoreUIKitIcon => {
    const MessageScrollerButtonIcon: NCoreUIKitIcon = ({
        customColor,
        color,
        size
    }) => {
        const rootContext = useMessageScrollerRootContext();

        return <AnimatedIcon
            customTheme={rootContext?.customTheme}
            customColor={customColor}
            animationTrigger="hover"
            animation="signature"
            color={color}
            icon={icon}
            size={size}
        />;
    };

    return MessageScrollerButtonIcon;
};

export const MESSAGE_SCROLLER_BUTTON_ICONS: Record<MessageScrollerButtonDirection, NCoreUIKitIcon> = {
    start: getMessageScrollerButtonIcon(ArrowUpIcon),
    end: getMessageScrollerButtonIcon(ArrowDownIcon)
};
